import { createSelector } from 'reselect'
import getNonExpiredPromoCodeSelector from 'modules/promo-codes/selectors/get-non-expired'
import { getAllNonExpiredPromoCodesSelector } from 'modules/promo-codes/selectors'
import { getSubTotalCartSelector } from 'modules/cart/selectors/get-sub-total'
import { getObjectUtil } from 'packages/src'

function getDiscountCartSelector () {
  return createSelector(
    getSubTotalCartSelector(),
    getNonExpiredPromoCodeSelector(),
    getAllNonExpiredPromoCodesSelector(),
    (subTotal, promoCode, promoCodes) => {
      const userDiscount = (
        promoCodes.reduce((discount, promoCode) => {
          if (promoCode.data.UserPromoCode) {
            discount += promoCode.data.value
          }
          return discount
        }, 0)
      )
      const promoCodeDiscount = getObjectUtil(promoCode, 'data.value') || 0
      const totalDiscount = userDiscount + promoCodeDiscount
      return subTotal * totalDiscount
    }
  )
}

export {
  getDiscountCartSelector
}
